import { render, staticRenderFns } from "./Navbar2.vue?vue&type=template&id=2de758ed&"
import script from "./Navbar2.vue?vue&type=script&lang=js&"
export * from "./Navbar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports